






















import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
    name: 'AdminPanel',
    computed: {
        ...mapGetters('auth', { isAdmin: 'isAdmin' })
    },
});
